import React from 'react';
import { RecoilRoot } from 'recoil'

import RouteLayout from './router/route'
import './styles/custom.css';
import './App.scss';
import './App.css';
import ic_apps from './images/icons8-squared-menu-24.png'
import { useLocation } from 'react-router'

export default function App({ pageProps }) {
  const location = useLocation();
  return (
    <div>
      <RecoilRoot>
          {/* <Header props={pageProps}/> */}
          <RouteLayout {...pageProps} />
      </RecoilRoot>
      {
        location.pathname === "/huawei" || location.pathname === "/another-apk" ? null
      : (
        <footer className="footer d-flex align-items-center border-top">
        <div className="container-fluid d-flex flex-wrap justify-content-between align-items-center">
          { console.log(location.pathname) }
          <div className="col-md-4 mb-0 d-flex align-items-center">
            <a href={process.env.REACT_APP_AUTH_URL} className="d-flex align-items-center text-dark" style={{ fontSize: "14px" }} >
              <img
                src={ic_apps}
                width={18}
                height={18}
                alt=""
                className='mr-2'
              />
              <span className='flex-grow-1 text-left mb-0 font-weight-bold'>All Service</span>
            </a>
          </div>
          <p className="text-muted col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto ">
            © สงวนลิขสิทธิ์ {new Date().getFullYear()} บริษัท ไทยเบฟเวอเรจ จำกัด (มหาชน)
          </p>

          <ul className="nav col-md-4 justify-content-end">
          </ul>

        </div>
      </footer>
  )
      }
    </div>
  )
}

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
